import NewScenicRoomForm from './NewScenicRoomForm'
import NewScenicRoomAccordion from './NewScenicRoomAccordion'
import ScenicRoomAccordionSummary from './ScenicRoomAccordionSummary'

NewScenicRoomAccordion.NewScenicRoomForm = NewScenicRoomForm
NewScenicRoomAccordion.ScenicRoomAccordionSummary = ScenicRoomAccordionSummary

export default NewScenicRoomAccordion
